(() => {
    window.$ = jQuery;
    const SELECTOR_SLICK = '.product__image-wrapper.slick-enabled';
    const SELECTOR_VIDEO = '.product video';
    const SETTINGS_SLICK = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev">&nbsp</button>',
        nextArrow: '<button type="button" class="slick-next">&nbsp</button>',
        arrows: true,
        autoplay: false,
    };

    const initSlick = () => {
        const element = $(SELECTOR_SLICK);
        element.slick(SETTINGS_SLICK);
    };

    document.addEventListener('DOMContentLoaded', () => {
        initSlick();

        $(SELECTOR_VIDEO).on('click', function (e) {
            let video = this;
            if (video.paused && !$(video).parent().hasClass(('playing'))) {
                if (!video.src && video.dataset.src) {
                    video.src = video.dataset.src;
                }
                setTimeout(function (){
                    video.play();
                }, 10)
                $(video).parent().addClass('playing played');
                $(video).attr('controls', true);
            }
        });

        document.querySelectorAll('.product video[data-src]').forEach(function (video) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        const v = entry.target;
                        if (!v.src && v.dataset.src) {
                            v.src = v.dataset.src;
                        }
                        v.play();
                        observer.disconnect();
                    }
                });
            }, { threshold: 0.25 });
            observer.observe(video);
        });
    });
})()
